module.exports = __webpack_public_path__ + "static/media/Rectangle3footer.6702e74a.png";